import React from 'react';
import { useFm } from '@web3/base-hooks';
import { Collapse } from '@bfe/moly';

import styles from './index.module.scss';

const TAC = () => {
  const fm = useFm();

  const items = [
    fm('AIDOL_TC1'),
    fm('AIDOL_TC2'),
    fm('AIDOL_TC3'),
    fm('AIDOL_TC4'),
    fm('AIDOL_TC5'),
    fm('AIDOL_TC6'),
    fm('AIDOL_TC7'),
    fm('AIDOL_TC8'),
    // fm('AIDOL_TC9'), // 弃用了
    fm('AIDOL_TC10'),
  ];
  return (
    <div className={styles.row}>
      <div className={styles.title}>{fm('TC')}</div>
      <div className={styles.content}>
        <ul>
          {items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default TAC;
